import { render, staticRenderFns } from "./qyzl_bzj.vue?vue&type=template&id=245f9081&scoped=true"
import script from "./qyzl_bzj.vue?vue&type=script&lang=js"
export * from "./qyzl_bzj.vue?vue&type=script&lang=js"
import style0 from "./qyzl_bzj.vue?vue&type=style&index=0&id=245f9081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f9081",
  null
  
)

export default component.exports